export const ActivityStandard = {
  CCSS: "Common Core State Standards (CCSS)",
  NGSS: "Next Generation Science Standards (NGSS)",
  NCSS: "National Curriculum Standards for Social Studies (NCSS)",
  AP: "Advanced Placement (AP) Standards",
  IB: "International Baccalaureate (IB) Standards",
  StateSpecific: "State-Specific Standards",
  Other: "Other",
} as const;

export function isActivityStandard(
  standard: string
): standard is (typeof ActivityStandard)[keyof typeof ActivityStandard] {
  return Object.values(ActivityStandard).includes(standard as any);
}
